interface Data {
  tripId: string;
}

export const requestScheduleChangeAlternative = async (data: Data) => {
  return new Promise((resolve, reject) => {
    console.log("POST requestScheduleChangeAlternative", data);
    setTimeout(() => {
      resolve(data);
    }, 2000);
  });
};
